// components/toast.jsx

import React from 'react';
// sonner kütüphanesinden gerekli component ve fonksiyonları import ediyoruz
import { Toaster as SonnerToaster, toast as sonnerToast } from 'sonner';

/**
 * Toaster Component
 * Bu component, projenizin ana dosyasına (App.jsx gibi) sadece bir kez eklenir.
 * 'sonner' kütüphanesinin temelini alır ve projenizin Tailwind temasıyla
 * (renkler, karanlık mod vb.) tam uyumlu çalışmasını sağlar.
 */
export const Toaster = (props) => {
  return (
    <SonnerToaster
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
};

/**
 * toast objesi
 * Projenizin herhangi bir yerinden bildirim göndermek için bu objeyi kullanacaksınız.
 * Hook kullanmanıza gerek kalmadan, doğrudan fonksiyonları çağırabilirsiniz.
 * Örn: toast.success('İşlem başarılı!');
 */
export const toast = {
  success: (message, options) => {
    return sonnerToast.success(message, options);
  },
  error: (message, options) => {
    return sonnerToast.error(message, options);
  },
  warning: (message, options) => {
    return sonnerToast.warning(message, options);
  },
  warn: (message, options) => {
    return sonnerToast.warning(message, options);
  },
  info: (message, options) => {
    return sonnerToast.info(message, options);
  },
  message: (message, options) => {
    return sonnerToast.message(message, options);
  },
  // Loading toast for async operations
  loading: (message, options) => {
    return sonnerToast.loading(message, options);
  },
  // Promise handling
  promise: (promise, messages, options) => {
    return sonnerToast.promise(promise, messages, options);
  },
  // Dismiss specific toast
  dismiss: (toastId) => {
    return sonnerToast.dismiss(toastId);
  },
  // Özel React component'leri göstermek için
  custom: (component, options) => {
    return sonnerToast(component, options);
  },
};